import THEME from 'pobble-components/dist/theme'

const { BREAKPOINTS } = THEME

const styles = {
  pendingTeacherBar: {
    background: '#d4e8fc',
    color: '#008bec',
    borderBottom: '1px solid #7dbaf5',
    width: '100%',
    padding: '10px 20px',
    fontSize: '14px',
    margin: 0,
    [`@media (min-width: ${BREAKPOINTS.SM})`]: {
      position: 'sticky',
      top: '0',
      left: '0',
      zIndex: '95'
    }
  },
  pendingTeacherLink: {
    textDecoration: 'none',
    color: '#008bec',
    fontWeight: 'bold'
  }
}

export default styles
